module.exports = __webpack_public_path__ + "static/media/v-offline.74b2d56a.gif";